import { useState } from "react";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

export const REQUEST_ERROR = "Something went wrong. Please try again.";

export const useRequestConnectedServiceReview = () => {
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const requestCallback = async (listingUuid: string) => {
    setError("");
    setIsSubmitting(true);

    try {
      await caseTransformingAxios.post("/api/v4/transactions/connected_services/ask_to_review", {
        uuid: listingUuid,
      });

      return true;
    } catch {
      setError(REQUEST_ERROR);
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { requestCallback, error, isSubmitting };
};

export default useRequestConnectedServiceReview;
